import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
  Divider,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';

interface NotFoundRestaurantsDialogProps {
  open: boolean;
  message: string;
  restaurants: string[];
  totalRestaurants?: number;
  onClose: () => void;
}

const NotFoundRestaurantsDialog: React.FC<NotFoundRestaurantsDialogProps> = ({
  open,
  message,
  restaurants,
  totalRestaurants,
  onClose,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography className={classes.headerTitle}>
          {t('attributeMassUpdate.completedWithWarning')}
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Box className={classes.section}>
          <Typography variant="body1" gutterBottom>
            {message}
          </Typography>
          {totalRestaurants && (
            <Typography variant="body1" gutterBottom>
              {t('attributeMassUpdate.totalRestaurants')}: {totalRestaurants}
            </Typography>
          )}
          <Typography variant="subtitle1" className={classes.sectionTitle}>
            {t('attributeMassUpdate.restaurantsNotFound')} ({restaurants.length}
            )
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {t('attributeMassUpdate.restaurantNumbersNotFound')}:
          </Typography>
          <Box className={classes.restaurantListText}>
            <Typography variant="body2" component="div">
              {restaurants.join(', ')}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions className={classes.actions}>
        <Button
          variant="outlined"
          onClick={onClose}
          className={classes.submitButton}
        >
          {t('app.common.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotFoundRestaurantsDialog;
